module.exports = __webpack_public_path__ + "img/sulfite.c11b47b7.svg";